export let SendTimeOptimizationErrorKeys;
(function (SendTimeOptimizationErrorKeys) {
  SendTimeOptimizationErrorKeys["TIME_NOT_SET"] = "SEND_TIME_OPTIMIZATION_TIME_NOT_SET";
  SendTimeOptimizationErrorKeys["LESS_THAN_24_HOURS"] = "SEND_TIME_OPTIMIZATION_LESS_THAN_24_HOURS";
  SendTimeOptimizationErrorKeys["START_IN_PAST"] = "SEND_TIME_OPTIMIZATION_START_IN_PAST";
  SendTimeOptimizationErrorKeys["PASSED"] = "SEND_TIME_OPTIMIZATION_PASSED";
  SendTimeOptimizationErrorKeys["TOO_SHORT"] = "SEND_TIME_OPTIMIZATION_TOO_SHORT";
  SendTimeOptimizationErrorKeys["TOO_LONG"] = "SEND_TIME_OPTIMIZATION_TOO_LONG";
  SendTimeOptimizationErrorKeys["END_BEFORE_START"] = "SEND_TIME_OPTIMIZATION_END_BEFORE_START";
})(SendTimeOptimizationErrorKeys || (SendTimeOptimizationErrorKeys = {}));